import toast from "react-hot-toast";
import AppToast, { ToastKind } from "./index";

export type { ToastKind };

export const showAppToast = (
  kind: ToastKind,
  message: string,
  detail?: string
) => {
  toast.custom(
    (t) => <AppToast t={t} kind={kind} message={message} detail={detail} />,
    {
      duration: 4200,
    }
  );
};
